import * as THREE from 'three';
import BaseMesh from './base-mesh';
class HeatMapComplex extends BaseMesh {
    constructor(data) {
        super(data);
        const { position, renderProps } = this.props;
        this.position.set(position.x, position.y, position.z);
        const { colorStops, size = 0, rotateX = 0, type, radius } = renderProps;
        this.rotation.x = Math.PI * rotateX;
        this.isObserver = true;
        // this.geometry = new THREE.CircleGeometry(50, 32);
        this.geometry = new THREE.PlaneGeometry(radius * 2, radius * 2);
        this.material = new THREE.MeshBasicMaterial({
            side: THREE.DoubleSide,
            map: this._draw(radius, colorStops, 200, type),
            transparent: true,
            depthTest: true,
            opacity: 1,
        });
    }
    update(data) {
        // const { position, renderProps } = data;
        // const { type, colorStops, size } = renderProps;
        // this.position.set(position.x, position.y, position.z);
        super.update(data);
    }
    onClick() {
        super.onClick();
    }
    getMaxMin(value) {
        let min = Number.MAX_SAFE_INTEGER;
        let max = -Number.MAX_SAFE_INTEGER;
        min = Math.min(min, value);
        max = Math.max(max, value);
        return { max, min };
    }
    _draw(radius, colorStops, size, type) {
        const canvas = document.createElement('canvas');
        canvas.width = radius * 2;
        canvas.height = radius * 2;
        const context = canvas.getContext('2d');
        if (context) {
            context.beginPath();
            context.arc(radius, radius, radius, 0, 2 * Math.PI);
            context.closePath();
            // 创建渐变色: r,g,b取值比较自由，我们只关注alpha的数值
            const radialGradient = context.createRadialGradient(radius, radius, 0, radius, radius, radius);
            // 添加一个由偏移值和颜色值指定的断点到渐变
            // radialGradient.addColorStop(1.0, "#FF000000");
            colorStops.forEach(({ offset, color }) => {
                radialGradient.addColorStop(offset, color);
            });
            context.fillStyle = radialGradient;
            const { max, min } = this.getMaxMin(size);
            // 设置globalAlpha: 需注意取值需规范在0-1之间
            const globalAlpha = (size - min) / (max - min);
            // context.globalAlpha = Math.max(Math.min(globalAlpha, 1), 0);
            // 填充颜色
            context.fill();
            const ctx = this.fillRoundRect(0, 0, 2, 2, 0.5, 'rgba(0,0,0,0.7)');
            const pattern = context.createPattern(ctx, 'repeat');
            context.fillStyle = pattern;
            context.fill();
        }
        const canvasTexture = new THREE.CanvasTexture(canvas);
        // canvasTexture.minFilter = THREE.NearestMipmapLinearFilter;
        // canvasTexture.magFilter = THREE.LinearFilter;
        canvasTexture.needsUpdate = true;
        return canvasTexture;
    }
    fillRoundRect(x, y, width, height, radius, /* optional */ fillColor) {
        const canvas = document.createElement('canvas');
        canvas.width = 1.5 * width;
        canvas.height = 1.5 * height;
        const context = canvas.getContext('2d');
        // 圆的直径必然要小于矩形的宽高
        if (2 * radius > width || 2 * radius > height) {
            return canvas;
        }
        if (context) {
            context.save();
            context.translate(x, y);
            // 绘制圆角矩形的各个边
            this.drawRoundRectPath(context, width, height, radius);
            context.fillStyle = fillColor || '#000'; // 若是给定了值就用给定的值否则给予默认值
            context.fill();
            context.restore();
        }
        return canvas;
    }
    drawRoundRectPath(cxt, width, height, radius) {
        cxt.beginPath();
        // 从右下角顺时针绘制，弧度从0到1/2PI
        cxt.arc(width - radius, height - radius, radius, 0, Math.PI / 2);
        // 矩形下边线
        cxt.lineTo(radius, height);
        // 左下角圆弧，弧度从1/2PI到PI
        cxt.arc(radius, height - radius, radius, Math.PI / 2, Math.PI);
        // 矩形左边线
        cxt.lineTo(0, radius);
        // 左上角圆弧，弧度从PI到3/2PI
        cxt.arc(radius, radius, radius, Math.PI, (Math.PI * 3) / 2);
        // 上边线
        cxt.lineTo(width - radius, 0);
        // 右上角圆弧
        cxt.arc(width - radius, radius, radius, (Math.PI * 3) / 2, Math.PI * 2);
        // 右边线
        cxt.lineTo(width, height - radius);
        cxt.closePath();
    }
    dispose() {
        const { onDestory } = this.props;
        this.parent?.remove(this);
        this.material.dispose();
        this.geometry.dispose();
        if (onDestory && typeof onDestory === 'function') {
            onDestory(this);
        }
    }
}
export default HeatMapComplex;
